import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { nestedRoutePath, routes } from '../../../constants/routes'

import AdminQuestionList from './list'
import AdminQuestionEdit from './edit'
import AdminQuestionCreate from './create'

const AdminQuestionsIndex = () => {
    return (
        <>
            <div className="builder-view">
                <Routes>
                    <Route path={nestedRoutePath(routes.adminQuestionIndex.path, routes.adminQuestionCreate.path)} element={<AdminQuestionCreate />} />
                    <Route path={nestedRoutePath(routes.adminQuestionIndex.path, routes.adminQuestionEdit.path)} element={<AdminQuestionEdit />} />
                    <Route index element={<AdminQuestionList />} />
                </Routes>
            </div>
        </>
    )
}

export default AdminQuestionsIndex
